export default {
    availability_title: {
        label: 'Naziv rasporeda',
        placeholder: 'Unesite naziv rasporeda.. Možete uneti ime osobe zadužene za raspored.',
        tool_tip_message: 'Unesite naziv rasporeda. Možete uneti ime osobe zadužene za raspored.',
    },

    booking_days_limit: {
        label: 'Dozvoli rezervaciju dana unapred',
        placeholder: 'Unesite broj',
        tool_tip_message: 'Maksimalan broj dana za rezervaciju slota unapred',
    },

    user_availability: {
        users: 'Korisnici kompanije',
        new_users: 'Novi korisnici',
        admin: 'Admin',
        performer: 'Izvođač',
        add_user: '+ Dodaj korisnika',
    },
    user_modal: {
        invite_user: 'Da li želite da pozovete korisnika?',
        found_user: 'Pronađen korisnik',
        user_email_not_found: 'Korisnik sa emailom:',
        user_email_not_found_1: 'ne postoji. Da li želite da pozovete korisnika?',
        user_list: 'Lista korisnika:',
    },
    errors: {
        user_in_company: 'Odabrani korisnik je vec u kompaniji, da dodate ovog korisnika idite na tab Korisnici kompanije!',
        user_already_added: 'Odabrani korisnik je vec dodat!',
    },
    modal: {
        heading: 'Da li želite da primenite izabrane slotove za više dana?',
        heading_days: 'Izaberite dane na kojima želite da primenite izabrane slotove',
    },
}
